import React, { useRef } from 'react'
import {
  Button,
  DialogContent,
  Grid,
  IconButton,
  Typography
} from '@material-ui/core'
import DialogAster from 'asterX-UIkit/Dialog/DialogAster'
import DialogTitleCustom from 'asterX-UIkit/Dialog/DialogTitleCustom'
import { Check, Error } from '@material-ui/icons'
import { GRAY_COLORS } from 'asterX-UIkit'

const NotificationModal = ({ error, open, onClose }) => {
  const modalRef = useRef(null)

  const handleClick = () => {}

  return (
    <DialogAster id="modal" onClose={onClose} open={open}>
      <DialogTitleCustom onClose={onClose}>
        <IconButton>{!error ? <Check /> : <Error />}</IconButton>
      </DialogTitleCustom>
      <DialogContent ref={modalRef}>
        <Grid item container xs={12} md={12}>
          <Typography style={{ fontSize: 18, fontWeight: 600 }}>
            {!error
              ? 'Ваша заявка успешно опубликована'
              : 'Что-то пошло не так'}
          </Typography>
          <Typography
            style={{
              fontSize: 14,
              fontWeight: 400,
              color: GRAY_COLORS[600]
            }}
          >
            {!error
              ? 'Вы можете отслеживать статусы ваших заявок в странице “Мои заявки”'
              : 'Заявка не создана, попробуйте еще раз'}
          </Typography>
        </Grid>
        <Grid
          item
          container
          xs={12}
          md={12}
          style={{ marginTop: 24 }}
          spacing={2}
        >
          <Grid item xs={12} md={12}>
            <Button
              fullWidth
              variant="contained"
              color={'primary'}
              onClick={handleClick}
            >
              {!error ? 'Мои заявки' : 'Попробовать еще раз'}
            </Button>
          </Grid>
          <Grid item xs={12} md={12}>
            <Button
              fullWidth
              variant="outlined"
              color={'primary'}
              onClick={onClose}
            >
              {'Отмена'}
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </DialogAster>
  )
}
export default NotificationModal
